import http from '@/utils/http';

/** /api/v1/intelligence_pc/user/info 接口返回的 groups 结构 */
interface IIntelligenceUserGroup {
  group_name?: string;
  email_suffix?: string;
}

/** /api/v1/intelligence_pc/user/info 接口返回的 data 结构 */
interface IIntelligenceUserInfoData {
  email?: string;
  groups?: IIntelligenceUserGroup[];
}

/** /api/v1/intelligence_pc/user/info 接口完整响应结构 */
interface IIntelligenceUserInfoResponse {
  data?: IIntelligenceUserInfoData;
  req?: {
    OpenId?: string;
  };
}

/** 模块级缓存，保证 intelligence 子系统全局只请求一次该接口 */
let userInfoResponsePromise: Promise<IIntelligenceUserInfoResponse | null> | null = null;

/**
 * 获取 /api/v1/intelligence_pc/user/info 接口完整响应（全局单例缓存）。
 * 登录态 Cookie 由项目统一 http 实例自动携带。
 */
export const fetchIntelligenceUserInfoResponse = (): Promise<IIntelligenceUserInfoResponse | null> => {
  if (userInfoResponsePromise === null) {
    userInfoResponsePromise = http({
      url: '/api/v1/intelligence_pc/user/info',
      method: 'post',
      data: {},
      rawData: true,
    })
      .then((response: IIntelligenceUserInfoResponse) => response || null)
      .catch(() => {
        // 请求失败后清空缓存，允许下次重试
        userInfoResponsePromise = null;
        return null;
      });
  }

  return userInfoResponsePromise;
};

/**
 * 获取当前用户所属组织的全部 group_name 列表。
 * 接口失败或未返回 groups 时返回空数组。
 */
export const getIntelligenceUserGroupNames = async (): Promise<string[]> => {
  const response = await fetchIntelligenceUserInfoResponse();
  return response?.data?.groups?.map((group) => group.group_name).filter((value): value is string => !!value) || [];
};
